import { render, staticRenderFns } from "./Events_Editing.vue?vue&type=template&id=ff0b5d94&scoped=true&"
import script from "./Events_Editing.vue?vue&type=script&lang=js&"
export * from "./Events_Editing.vue?vue&type=script&lang=js&"
import style0 from "./Events_Editing.vue?vue&type=style&index=0&id=ff0b5d94&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff0b5d94",
  null
  
)

export default component.exports